import {SelectItem} from './select-item';
import {FieldConfig} from '../../dynamic-field/field.config';
import {Type} from '@angular/core';
import {SourceItem} from './source-item';
import {ValueItem} from './value-item';

export interface FilterSelectFieldConfig extends FieldConfig<any> {
    getSource?: () => Promise<SelectItem[]>;
    source?: SelectItem[];
    sourceItemComponent?: Type<SourceItem>;
    valueItemComponent?: Type<ValueItem>;
    multiple?: boolean;
    openOnInit?: boolean;
    removeClearButton?: boolean;
    dropDownPanelClass?: string;
    allowAddItem?: boolean;
    groupedSource?: boolean;
    onItemAdded?: (value: any) => any;
    multiline?: boolean;
    customSearch?: (term: string, item: SelectItem) => boolean;
    // groupedSource: { id: number, subItem: SelectItem[] };
}
